import { render } from "./AutoMenuLayout.vue?vue&type=template&id=0106e4ce"
import script from "./AutoMenuLayout.vue?vue&type=script&lang=js"
export * from "./AutoMenuLayout.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__